import React, { useEffect } from 'react';

import NestedField from './NestedField';
import Section from './Section';
import OtherField from './OtherField';

import useForm from '../../../../Form/CrudForm/hooks/useForm';

function clearUnselectedSubfields(schema, values, setFieldValue) {
  function collectNames(fields) {
    return fields.reduce((names, field) => {
      names.push(field.name);
      if (field.subFields) {
        names.push(...collectNames(field.subFields));
      }
      if (field.type === 'section' && field.fields) {
        names.push(...collectNames(field.fields));
      }
      return names;
    }, []);
  }

  schema.forEach((field) => {
    // If this field has subFields, treat it as a parent
    if (field.subFields && values[field.name] === false) {
      // gather every descendant name and clear it
      const allSubNames = collectNames(field.subFields);
      allSubNames.forEach((subName) => {
        // Only clear if it's not already ''
        if (values[subName] !== '') {
          setFieldValue(subName, '');
        }
      });
    }
    // dive into sections too
    if (field.type === 'section' && field.fields) {
      clearUnselectedSubfields(field.fields, values, setFieldValue);
    }
  });
}

function flattenFields(fields) {
  const result = [];

  function traverse(arr) {
    arr.forEach((field) => {
      if (field.type === 'section') {
        traverse(field.fields || []);
      } else {
        const { subFields, ...shallow } = field;
        result.push(shallow);

        if (Array.isArray(subFields)) {
          traverse(subFields);
        }
      }
    });
  }

  traverse(fields);
  return result;
}

export default function DeclarationForm({
  fields,
  borrower,
  updateBorrower,
  isPending,
  createBorrower,
}) {
  const flatFields = flattenFields(fields);

  const formik = useForm({
    createHandler: createBorrower,
    updateHandler: updateBorrower,
    serverData: borrower,
    fields: flatFields,
  });

  useEffect(() => {
    if (formik.values) {
      clearUnselectedSubfields(fields, formik.values, formik.setFieldValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values, fields]);

  return (
    <div>
      {fields.map((field) => {
        if (field.type === 'section') {
          return <Section key={field.name} field={field} formik={formik} />;
        }
        if (field.type === 'checkbox') {
          return <NestedField key={field.name} field={field} formik={formik} />;
        }

        return <OtherField key={field.name} field={field} formik={formik} />;
      })}
      <button
        disabled={isPending}
        type="button"
        onClick={formik.handleSubmit}
        className="inline-flex items-center px-5 py-2.5 mt-4 sm:mt-6 text-sm font-medium text-center text-white bg-primary-700 rounded-lg focus:ring-4 focus:ring-primary-200 dark:focus:ring-primary-900 hover:bg-primary-800 cursor-pointer"
      >
        Update Borrower
      </button>
    </div>
  );
}
